<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>
    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <div v-for="(item, index) in fields" :key="index" v-if="fields">
        <rest-form-item
          :label="item.label"
          :prop="`params.${item.name}`"
          :rules="{
            required: true,
            message: $t('RestForm_FieldIsRequired')
          }"
          v-if="item.type === 'text'"
        >
          <el-input v-model="modelParams[item.name]" />
        </rest-form-item>
      </div>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import _ from 'lodash'
import objectPath from 'object-path'

export default {
  name: 'DynamicSettings',

  components: {
    FormSection,
    RestFormItem
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  mounted() {
    RestApi(this.fetchFieldsEndpoint)
      .then(({ data }) => {
        this.dynamicPromotion = data
        this.fields.forEach(field => {
          this.$set(
            this.modelParams,
            field.name,
            objectPath.get(this.model.params, field.name)
          )
        })
      })
      .catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
  },
  data() {
    return {
      modelParams: {},
      dynamicPromotion: null,
      urlValidationMessage: this.$t('RestForm_FieldInvalidUrl'),
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        }
      }
    }
  },
  computed: {
    dynamicIntegrationID() {
      return this.model.dynamic_integration_id
        ? this.model.dynamic_integration_id
        : this.$route.query.dynamic_integration_id
    },
    fields() {
      return this.dynamicPromotion && this.dynamicPromotion.fields
        ? this.dynamicPromotion.fields
        : []
    },
    fetchFieldsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/dynamic-promotions/${this.dynamicIntegrationID}`,
        params: {
          expand: 'fields'
        }
      })
    }
  },

  watch: {
    modelParams: {
      handler(value) {
        _.each(value, (val, key) => {
          let temp = { ...this.model.params }
          objectPath.set(temp, key, val)
          this.$set(this.model, 'params', temp)
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/dynamicpromotions/DynamicSettings.vue